/* tslint:disable */
/* eslint-disable */
/**
 * BIM Data Downloader API
 * Provides a localized JavaScript snippet for the BIM catalog download modal and an endpoint to check localized Revit file availability.
 *
 * The version of the OpenAPI document:
 * Contact: info@ekkodale.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AxiosInstance, AxiosPromise, AxiosRequestConfig } from "axios"
import globalAxios from "axios"
import type { Configuration } from "./configuration"
// Some imports not used depending on template conditions
// @ts-ignore
import type { RequestArgs } from "./base"
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  setApiKeyToObject,
  setSearchParams,
  toPathString,
} from "./common"
// @ts-ignore
import { BASE_PATH, BaseAPI, RequiredError } from "./base"

/**
 *
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
  [key: string]: any

  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  type?: string | null
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  title?: string | null
  /**
   *
   * @type {number}
   * @memberof ProblemDetails
   */
  status?: number | null
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  detail?: string | null
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  instance?: string | null
}

/**
 * RevitFileApi - axios parameter creator
 * @export
 */
export const RevitFileApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns `true` if the localized BIM Revit file **and** its translations are ready; otherwise `false`.
     * @summary Revit file availability
     * @param {string} productId Product identifier used to locate the localized BIM Revit file.
     * @param {string} locale Locale. Default is &#x60;en-GB&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRevitFileAvailability: async (
      productId: string,
      locale: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("getRevitFileAvailability", "productId", productId)
      // verify required parameter 'locale' is not null or undefined
      assertParamExists("getRevitFileAvailability", "locale", locale)
      const localVarPath = `/v1/api/revit-file/availability`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication apiKeyHeader required
      await setApiKeyToObject(localVarHeaderParameter, "Ocp-Apim-Subscription-Key", configuration)

      // authentication apiKeyQuery required
      await setApiKeyToObject(localVarQueryParameter, "subscription-key", configuration)

      if (productId !== undefined) {
        localVarQueryParameter["productId"] = productId
      }

      if (locale !== undefined) {
        localVarQueryParameter["locale"] = locale
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RevitFileApi - functional programming interface
 * @export
 */
export const RevitFileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RevitFileApiAxiosParamCreator(configuration)
  return {
    /**
     * Returns `true` if the localized BIM Revit file **and** its translations are ready; otherwise `false`.
     * @summary Revit file availability
     * @param {string} productId Product identifier used to locate the localized BIM Revit file.
     * @param {string} locale Locale. Default is &#x60;en-GB&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRevitFileAvailability(
      productId: string,
      locale: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getRevitFileAvailability(productId, locale, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * RevitFileApi - factory interface
 * @export
 */
export const RevitFileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = RevitFileApiFp(configuration)
  return {
    /**
     * Returns `true` if the localized BIM Revit file **and** its translations are ready; otherwise `false`.
     * @summary Revit file availability
     * @param {RevitFileApiGetRevitFileAvailabilityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRevitFileAvailability(
      requestParameters: RevitFileApiGetRevitFileAvailabilityRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<boolean> {
      return localVarFp
        .getRevitFileAvailability(requestParameters.productId, requestParameters.locale, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for getRevitFileAvailability operation in RevitFileApi.
 * @export
 * @interface RevitFileApiGetRevitFileAvailabilityRequest
 */
export interface RevitFileApiGetRevitFileAvailabilityRequest {
  /**
   * Product identifier used to locate the localized BIM Revit file.
   * @type {string}
   * @memberof RevitFileApiGetRevitFileAvailability
   */
  readonly productId: string

  /**
   * Locale. Default is &#x60;en-GB&#x60;.
   * @type {string}
   * @memberof RevitFileApiGetRevitFileAvailability
   */
  readonly locale: string
}

/**
 * RevitFileApi - object-oriented interface
 * @export
 * @class RevitFileApi
 * @extends {BaseAPI}
 */
export class RevitFileApi extends BaseAPI {
  /**
   * Returns `true` if the localized BIM Revit file **and** its translations are ready; otherwise `false`.
   * @summary Revit file availability
   * @param {RevitFileApiGetRevitFileAvailabilityRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RevitFileApi
   */
  public getRevitFileAvailability(
    requestParameters: RevitFileApiGetRevitFileAvailabilityRequest,
    options?: AxiosRequestConfig
  ) {
    return RevitFileApiFp(this.configuration)
      .getRevitFileAvailability(requestParameters.productId, requestParameters.locale, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * UICatalogApi - axios parameter creator
 * @export
 */
export const UICatalogApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Returns a localized JavaScript snippet with plugin buttons, download links, and translations. Returns **404 Not Found** if the product/locale cannot be resolved.
     * @summary Get BIM Catalog Script
     * @param {string} productId Product identifier used to generate the script.
     * @param {string} locale Locale. Default is &#x60;en-GB&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUICatalogScript: async (
      productId: string,
      locale: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'productId' is not null or undefined
      assertParamExists("getUICatalogScript", "productId", productId)
      // verify required parameter 'locale' is not null or undefined
      assertParamExists("getUICatalogScript", "locale", locale)
      const localVarPath = `/v1/api/uicatalog/script`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication apiKeyHeader required
      await setApiKeyToObject(localVarHeaderParameter, "Ocp-Apim-Subscription-Key", configuration)

      // authentication apiKeyQuery required
      await setApiKeyToObject(localVarQueryParameter, "subscription-key", configuration)

      if (productId !== undefined) {
        localVarQueryParameter["productId"] = productId
      }

      if (locale !== undefined) {
        localVarQueryParameter["locale"] = locale
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UICatalogApi - functional programming interface
 * @export
 */
export const UICatalogApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UICatalogApiAxiosParamCreator(configuration)
  return {
    /**
     * Returns a localized JavaScript snippet with plugin buttons, download links, and translations. Returns **404 Not Found** if the product/locale cannot be resolved.
     * @summary Get BIM Catalog Script
     * @param {string} productId Product identifier used to generate the script.
     * @param {string} locale Locale. Default is &#x60;en-GB&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getUICatalogScript(
      productId: string,
      locale: string,
      options?: AxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getUICatalogScript(productId, locale, options)
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)
    },
  }
}

/**
 * UICatalogApi - factory interface
 * @export
 */
export const UICatalogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  const localVarFp = UICatalogApiFp(configuration)
  return {
    /**
     * Returns a localized JavaScript snippet with plugin buttons, download links, and translations. Returns **404 Not Found** if the product/locale cannot be resolved.
     * @summary Get BIM Catalog Script
     * @param {UICatalogApiGetUICatalogScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUICatalogScript(
      requestParameters: UICatalogApiGetUICatalogScriptRequest,
      options?: AxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .getUICatalogScript(requestParameters.productId, requestParameters.locale, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * Request parameters for getUICatalogScript operation in UICatalogApi.
 * @export
 * @interface UICatalogApiGetUICatalogScriptRequest
 */
export interface UICatalogApiGetUICatalogScriptRequest {
  /**
   * Product identifier used to generate the script.
   * @type {string}
   * @memberof UICatalogApiGetUICatalogScript
   */
  readonly productId: string

  /**
   * Locale. Default is &#x60;en-GB&#x60;.
   * @type {string}
   * @memberof UICatalogApiGetUICatalogScript
   */
  readonly locale: string
}

/**
 * UICatalogApi - object-oriented interface
 * @export
 * @class UICatalogApi
 * @extends {BaseAPI}
 */
export class UICatalogApi extends BaseAPI {
  /**
   * Returns a localized JavaScript snippet with plugin buttons, download links, and translations. Returns **404 Not Found** if the product/locale cannot be resolved.
   * @summary Get BIM Catalog Script
   * @param {UICatalogApiGetUICatalogScriptRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UICatalogApi
   */
  public getUICatalogScript(requestParameters: UICatalogApiGetUICatalogScriptRequest, options?: AxiosRequestConfig) {
    return UICatalogApiFp(this.configuration)
      .getUICatalogScript(requestParameters.productId, requestParameters.locale, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
